import {
  ChatConversation,
  SendChatMessageResponse,
  InputType,
} from '@/shared/types/yakurekiChat'
import client from '@/shared/apis/client'

/**
 * チャット履歴の取得
 */
export const getChatHistory = async (
  yakurekiId: string
): Promise<ChatConversation> => {
  const endpoint = `/api/events/${yakurekiId}/chat/`
  const response = await client.get(endpoint)
  return response.data
}

/**
 * チャットメッセージの送信（SOAPの更新）
 *
 * テキスト: JSON送信
 * 音声: multipart/form-data送信（バックエンドで文字起こし→SOAP更新）
 */
export const sendChatMessage = async (
  yakurekiId: string,
  params: {
    message?: string
    audioFile?: File | Blob
    inputType: InputType
    allowedSections?: string[]
    // この依頼で足した資料の id (資料つきなら message は空でよい。back はその資料だけを読む)
    attachmentIds?: string[]
  }
): Promise<SendChatMessageResponse> => {
  const endpoint = `/api/events/${yakurekiId}/chat/messages/`

  if (params.inputType === 'voice' && params.audioFile) {
    const formData = new FormData()
    formData.append('audio', params.audioFile, 'voice-memo.mp3')
    formData.append('input_type', 'voice')
    if (params.allowedSections) {
      formData.append(
        'allowed_sections',
        JSON.stringify(params.allowedSections)
      )
    }
    const response = await client.post(endpoint, formData)
    return response.data
  }

  const body: Record<string, unknown> = {
    message: params.message,
    input_type: params.inputType,
  }
  if (params.allowedSections) {
    body.allowed_sections = params.allowedSections
  }
  if (params.attachmentIds && params.attachmentIds.length > 0) {
    body.attachment_ids = params.attachmentIds
  }
  const response = await client.post(endpoint, body)
  return response.data
}
